import React from 'react';
import { Field, RadioGroup, TextOutput, NumericInput } from '../../Core';
import { ListFieldSection } from '../../Layout';
import { withInjectedProps } from '../../Core/InjectedPropsContext';
import { FormatTypes } from '../../../Lib/Format';

let BalanceEquipmentSection: React.FC = () => {
  return (
    <>
      <ListFieldSection>
        <Field input={<TextOutput />} label="Balance" name="Code" />
        <Field
          format={{ type: FormatTypes.AsEntered }}
          input={<NumericInput />}
          label="Readable to Nearest"
          name="Readability"
        />
        <Field
          input={<RadioGroup />}
          label="Units"
          name="Uom"
          options={[
            { label: 'grams', value: 'g' },
            { label: 'kilograms', value: 'kg' },
            { label: 'pounds', value: 'lb' },
          ]}
        />
      </ListFieldSection>
    </>
  );
};

BalanceEquipmentSection = withInjectedProps(BalanceEquipmentSection);

export default BalanceEquipmentSection;
export { BalanceEquipmentSection };
